import React, { useRef } from "react";
import { Field, useField } from "formik";
import useScrollToError from "src/commun/composants/formulaire/formik/hooks/useScrollToError";
import AppSelect, { AppSelectProps } from "src/commun/composants/formulaire/AppSelect/AppSelect";


export type AppSelectFormikProps = Omit<AppSelectProps, "onChange" | "onBlur" | "value" | "error"> & {
  formulaireSoumis?: boolean;
};

const AppSelectFormik = ({ name, formulaireSoumis = false, ...reste }: AppSelectFormikProps) => {
  const [, { error, touched }] = useField(name);
  const ref = useRef(undefined);
  useScrollToError(name, ref);

  return (
    <Field fieldRef={ref} name={name} error={error} touched={formulaireSoumis || touched} as={AppSelect} {...reste} />
  );
};

export default AppSelectFormik;
